import React, { useState, useRef, useEffect } from "react";

/**
 * Composant de saisie de pays avec suggestions automatiques ET liste complète
 */
const CountryInput = ({
  value,
  onChange,
  placeholder = "Tapez votre pays...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Liste des pays avec drapeaux
  const countries = [
    { name: "Afghanistan", flag: "🇦🇫" },
    { name: "Afrique du Sud", flag: "🇿🇦" },
    { name: "Albanie", flag: "🇦🇱" },
    { name: "Algérie", flag: "🇩🇿" },
    { name: "Allemagne", flag: "🇩🇪" },
    { name: "Andorre", flag: "🇦🇩" },
    { name: "Angola", flag: "🇦🇴" },
    { name: "Arabie Saoudite", flag: "🇸🇦" },
    { name: "Argentine", flag: "🇦🇷" },
    { name: "Arménie", flag: "🇦🇲" },
    { name: "Australie", flag: "🇦🇺" },
    { name: "Autriche", flag: "🇦🇹" },
    { name: "Azerbaïdjan", flag: "🇦🇿" },
    { name: "Bahamas", flag: "🇧🇸" },
    { name: "Bahreïn", flag: "🇧🇭" },
    { name: "Bangladesh", flag: "🇧🇩" },
    { name: "Barbade", flag: "🇧🇧" },
    { name: "Belgique", flag: "🇧🇪" },
    { name: "Belize", flag: "🇧🇿" },
    { name: "Bénin", flag: "🇧🇯" },
    { name: "Bhoutan", flag: "🇧🇹" },
    { name: "Biélorussie", flag: "🇧🇾" },
    { name: "Birmanie", flag: "🇲🇲" },
    { name: "Bolivie", flag: "🇧🇴" },
    { name: "Bosnie-Herzégovine", flag: "🇧🇦" },
    { name: "Botswana", flag: "🇧🇼" },
    { name: "Brésil", flag: "🇧🇷" },
    { name: "Brunei", flag: "🇧🇳" },
    { name: "Bulgarie", flag: "🇧🇬" },
    { name: "Burkina Faso", flag: "🇧🇫" },
    { name: "Burundi", flag: "🇧🇮" },
    { name: "Cambodge", flag: "🇰🇭" },
    { name: "Cameroun", flag: "🇨🇲" },
    { name: "Canada", flag: "🇨🇦" },
    { name: "Cap-Vert", flag: "🇨🇻" },
    { name: "Chili", flag: "🇨🇱" },
    { name: "Chine", flag: "🇨🇳" },
    { name: "Chypre", flag: "🇨🇾" },
    { name: "Colombie", flag: "🇨🇴" },
    { name: "Comores", flag: "🇰🇲" },
    { name: "Congo", flag: "🇨🇬" },
    { name: "Corée du Nord", flag: "🇰🇵" },
    { name: "Corée du Sud", flag: "🇰🇷" },
    { name: "Costa Rica", flag: "🇨🇷" },
    { name: "Côte d'Ivoire", flag: "🇨🇮" },
    { name: "Croatie", flag: "🇭🇷" },
    { name: "Cuba", flag: "🇨🇺" },
    { name: "Danemark", flag: "🇩🇰" },
    { name: "Djibouti", flag: "🇩🇯" },
    { name: "Dominique", flag: "🇩🇲" },
    { name: "Égypte", flag: "🇪🇬" },
    { name: "Émirats Arabes Unis", flag: "🇦🇪" },
    { name: "Équateur", flag: "🇪🇨" },
    { name: "Érythrée", flag: "🇪🇷" },
    { name: "Espagne", flag: "🇪🇸" },
    { name: "Estonie", flag: "🇪🇪" },
    { name: "États-Unis", flag: "🇺🇸" },
    { name: "Éthiopie", flag: "🇪🇹" },
    { name: "Fidji", flag: "🇫🇯" },
    { name: "Finlande", flag: "🇫🇮" },
    { name: "France", flag: "🇫🇷" },
    { name: "Gabon", flag: "🇬🇦" },
    { name: "Gambie", flag: "🇬🇲" },
    { name: "Géorgie", flag: "🇬🇪" },
    { name: "Ghana", flag: "🇬🇭" },
    { name: "Grèce", flag: "🇬🇷" },
    { name: "Grenade", flag: "🇬🇩" },
    { name: "Guatemala", flag: "🇬🇹" },
    { name: "Guinée", flag: "🇬🇳" },
    { name: "Guinée équatoriale", flag: "🇬🇶" },
    { name: "Guinée-Bissau", flag: "🇬🇼" },
    { name: "Guyana", flag: "🇬🇾" },
    { name: "Haïti", flag: "🇭🇹" },
    { name: "Honduras", flag: "🇭🇳" },
    { name: "Hongrie", flag: "🇭🇺" },
    { name: "Inde", flag: "🇮🇳" },
    { name: "Indonésie", flag: "🇮🇩" },
    { name: "Irak", flag: "🇮🇶" },
    { name: "Iran", flag: "🇮🇷" },
    { name: "Irlande", flag: "🇮🇪" },
    { name: "Islande", flag: "🇮🇸" },
    { name: "Israël", flag: "🇮🇱" },
    { name: "Italie", flag: "🇮🇹" },
    { name: "Jamaïque", flag: "🇯🇲" },
    { name: "Japon", flag: "🇯🇵" },
    { name: "Jordanie", flag: "🇯🇴" },
    { name: "Kazakhstan", flag: "🇰🇿" },
    { name: "Kenya", flag: "🇰🇪" },
    { name: "Kirghizistan", flag: "🇰🇬" },
    { name: "Kiribati", flag: "🇰🇮" },
    { name: "Kosovo", flag: "🇽🇰" },
    { name: "Koweït", flag: "🇰🇼" },
    { name: "Laos", flag: "🇱🇦" },
    { name: "Lesotho", flag: "🇱🇸" },
    { name: "Lettonie", flag: "🇱🇻" },
    { name: "Liban", flag: "🇱🇧" },
    { name: "Liberia", flag: "🇱🇷" },
    { name: "Libye", flag: "🇱🇾" },
    { name: "Liechtenstein", flag: "🇱🇮" },
    { name: "Lituanie", flag: "🇱🇹" },
    { name: "Luxembourg", flag: "🇱🇺" },
    { name: "Macédoine du Nord", flag: "🇲🇰" },
    { name: "Madagascar", flag: "🇲🇬" },
    { name: "Malaisie", flag: "🇲🇾" },
    { name: "Malawi", flag: "🇲🇼" },
    { name: "Maldives", flag: "🇲🇻" },
    { name: "Mali", flag: "🇲🇱" },
    { name: "Malte", flag: "🇲🇹" },
    { name: "Maroc", flag: "🇲🇦" },
    { name: "Maurice", flag: "🇲🇺" },
    { name: "Mauritanie", flag: "🇲🇷" },
    { name: "Mexique", flag: "🇲🇽" },
    { name: "Micronésie", flag: "🇫🇲" },
    { name: "Moldavie", flag: "🇲🇩" },
    { name: "Monaco", flag: "🇲🇨" },
    { name: "Mongolie", flag: "🇲🇳" },
    { name: "Monténégro", flag: "🇲🇪" },
    { name: "Mozambique", flag: "🇲🇿" },
    { name: "Namibie", flag: "🇳🇦" },
    { name: "Nauru", flag: "🇳🇷" },
    { name: "Népal", flag: "🇳🇵" },
    { name: "Nicaragua", flag: "🇳🇮" },
    { name: "Niger", flag: "🇳🇪" },
    { name: "Nigeria", flag: "🇳🇬" },
    { name: "Norvège", flag: "🇳🇴" },
    { name: "Nouvelle-Zélande", flag: "🇳🇿" },
    { name: "Oman", flag: "🇴🇲" },
    { name: "Ouganda", flag: "🇺🇬" },
    { name: "Ouzbékistan", flag: "🇺🇿" },
    { name: "Pakistan", flag: "🇵🇰" },
    { name: "Palaos", flag: "🇵🇼" },
    { name: "Palestine", flag: "🇵🇸" },
    { name: "Panama", flag: "🇵🇦" },
    { name: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
    { name: "Paraguay", flag: "🇵🇾" },
    { name: "Pays-Bas", flag: "🇳🇱" },
    { name: "Pérou", flag: "🇵🇪" },
    { name: "Philippines", flag: "🇵🇭" },
    { name: "Pologne", flag: "🇵🇱" },
    { name: "Portugal", flag: "🇵🇹" },
    { name: "Qatar", flag: "🇶🇦" },
    { name: "République Centrafricaine", flag: "🇨🇫" },
    { name: "République Démocratique du Congo", flag: "🇨🇩" },
    { name: "République Dominicaine", flag: "🇩🇴" },
    { name: "République Tchèque", flag: "🇨🇿" },
    { name: "Roumanie", flag: "🇷🇴" },
    { name: "Royaume-Uni", flag: "🇬🇧" },
    { name: "Russie", flag: "🇷🇺" },
    { name: "Rwanda", flag: "🇷🇼" },
    { name: "Saint-Christophe-et-Niévès", flag: "🇰🇳" },
    { name: "Saint-Marin", flag: "🇸🇲" },
    { name: "Saint-Vincent-et-les-Grenadines", flag: "🇻🇨" },
    { name: "Sainte-Lucie", flag: "🇱🇨" },
    { name: "Salomon", flag: "🇸🇧" },
    { name: "Salvador", flag: "🇸🇻" },
    { name: "Samoa", flag: "🇼🇸" },
    { name: "Sao Tomé-et-Principe", flag: "🇸🇹" },
    { name: "Sénégal", flag: "🇸🇳" },
    { name: "Serbie", flag: "🇷🇸" },
    { name: "Seychelles", flag: "🇸🇨" },
    { name: "Sierra Leone", flag: "🇸🇱" },
    { name: "Singapour", flag: "🇸🇬" },
    { name: "Slovaquie", flag: "🇸🇰" },
    { name: "Slovénie", flag: "🇸🇮" },
    { name: "Somalie", flag: "🇸🇴" },
    { name: "Soudan", flag: "🇸🇩" },
    { name: "Soudan du Sud", flag: "🇸🇸" },
    { name: "Sri Lanka", flag: "🇱🇰" },
    { name: "Suède", flag: "🇸🇪" },
    { name: "Suisse", flag: "🇨🇭" },
    { name: "Suriname", flag: "🇸🇷" },
    { name: "Syrie", flag: "🇸🇾" },
    { name: "Tadjikistan", flag: "🇹🇯" },
    { name: "Tanzanie", flag: "🇹🇿" },
    { name: "Tchad", flag: "🇹🇩" },
    { name: "Thaïlande", flag: "🇹🇭" },
    { name: "Timor oriental", flag: "🇹🇱" },
    { name: "Togo", flag: "🇹🇬" },
    { name: "Tonga", flag: "🇹🇴" },
    { name: "Trinité-et-Tobago", flag: "🇹🇹" },
    { name: "Tunisie", flag: "🇹🇳" },
    { name: "Turkménistan", flag: "🇹🇲" },
    { name: "Turquie", flag: "🇹🇷" },
    { name: "Tuvalu", flag: "🇹🇻" },
    { name: "Ukraine", flag: "🇺🇦" },
    { name: "Uruguay", flag: "🇺🇾" },
    { name: "Vanuatu", flag: "🇻🇺" },
    { name: "Vatican", flag: "🇻🇦" },
    { name: "Venezuela", flag: "🇻🇪" },
    { name: "Viêt Nam", flag: "🇻🇳" },
    { name: "Yémen", flag: "🇾🇪" },
    { name: "Zambie", flag: "🇿🇲" },
    { name: "Zimbabwe", flag: "🇿🇼" },
  ];

  // Filtrer les pays selon la saisie
  const filterCountries = (input) => {
    if (!input || input.length < 2) {
      setFilteredCountries([]);
      return;
    }

    const filtered = countries.filter((country) =>
      country.name.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredCountries(filtered.slice(0, 8)); // Limiter à 8 suggestions
  };

  // Gérer le changement de saisie
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange(e);
    filterCountries(inputValue);
    setIsOpen(inputValue.length >= 2);
  };

  // Sélectionner un pays
  const selectCountry = (country) => {
    onChange({ target: { name: "country", value: country.name } });
    setIsOpen(false);
    setFilteredCountries([]);
  };

  // Fermer le dropdown en cliquant ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <div className="relative group">
        <div className="relative">
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-2xl z-10">
            🌍
          </div>
          <input
            ref={inputRef}
            type="text"
            name="country"
            value={value}
            onChange={handleInputChange}
            className="w-full pl-14 pr-4 py-4 border-2 border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 text-base font-medium bg-gradient-to-r from-white to-blue-50/30 hover:border-blue-400 shadow-sm focus:shadow-lg"
            placeholder={placeholder}
            autoComplete="off"
          />
        </div>

        {/* Dropdown des suggestions avec design moderne */}
        {isOpen && filteredCountries.length > 0 && (
          <div
            ref={dropdownRef}
            className="absolute z-50 w-full mt-2 bg-white border-2 border-blue-200 rounded-2xl shadow-2xl max-h-72 overflow-y-auto backdrop-blur-lg"
          >
            <div className="p-2">
              {filteredCountries.map((country, index) => (
                <div
                  key={index}
                  className="group/item px-4 py-3 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 cursor-pointer rounded-xl mb-1 last:mb-0 flex items-center gap-3 transition-all duration-200 transform hover:scale-[1.02] hover:shadow-md"
                  onClick={() => selectCountry(country)}
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-100 to-indigo-100 rounded-xl group-hover/item:scale-110 transition-transform duration-300">
                    <span className="text-2xl">{country.flag}</span>
                  </div>
                  <span className="text-gray-800 font-semibold group-hover/item:text-blue-600 transition-colors">
                    {country.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Message si aucun pays trouvé avec design moderne */}
        {isOpen && filteredCountries.length === 0 && value.length >= 2 && (
          <div
            ref={dropdownRef}
            className="absolute z-50 w-full mt-2 bg-white border-2 border-gray-200 rounded-2xl shadow-xl"
          >
            <div className="px-4 py-6 text-gray-500 text-center">
              <div className="text-4xl mb-2">🔍</div>
              <p className="font-medium">Aucun pays trouvé pour "{value}"</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountryInput;
